export default {
  /**
   * Removes all items from client session storage.
   */
  clear: () => {
    window.sessionStorage.clear()
  },

  /**
   * Retrieves a named item from client session storage.
   *
   * @param key - Name of the item to retrieve.
   * @return Deserialized value of the item.
   */
  getItem: (key: string) => {
    try {
      const value = window.sessionStorage.getItem(key)

      if (value === null || value === undefined) {
        return null
      }

      return JSON.parse(value)
    } catch {
      return null
    }
  },

  /**
   * Determines whether an item by a given name exists in client session storage.
   *
   * @param key - Name of the item to test.
   * @return Whether the provided key exists in client session storage.
   */
  hasItem: (key: string) => window.sessionStorage.getItem(key) !== null,

  /**
   * Removes a named item from client session storage.
   *
   * @param key - Name of the item to remove.
   */
  removeItem: (key: string) => {
    window.sessionStorage.removeItem(key)
  },

  /**
   * Saves a named item and related value to client session storage.
   *
   * @param key - Name of the item to set.
   * @param value - Value of the item to set. Must be serializable.
   */
  setItem: (key: string, value: any) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value))
    } catch {
      // swallow storage full exception as `getItem` will properly default a not found item
    }
  }
}
